<template>
  <div class="marked-html" v-html="parsedMarkdown"></div>
</template>

<script>
import marked from 'marked'

marked.setOptions({
  highlight: (code, lang) => {
    const hljs = require('highlightjs')
    return hljs.highlight(lang || 'text', code).value
  },
  langPrefix: 'hljs ',
  smartLists: true,
  smartypants: true,
  xhtml: true,
  sanitize: true
})

export default {
  props: {
    source: String
  },
  computed: {
    parsedMarkdown () {
      return marked(this.source)
    }
  }
}
</script>
